import type { CSSProperties } from "react";

import { DotLottieReact } from "@lottiefiles/dotlottie-react";

import src from "./ListeningLottie.json?url";

export function ListeningAnimation({ style }: { style?: CSSProperties }) {
    // The 24x24 asset is square; a <canvas> has no intrinsic ratio, so pin it while honoring the caller's width.
    // mixBlendMode: screen drops dotlottie's opaque-black canvas against the dark surface (no off-shade box).
    // Keep this in the style prop, not className: DotLottieReact drops `style` when a `className` is also passed.
    return (
        <DotLottieReact
            style={{ aspectRatio: "1 / 1", mixBlendMode: "screen", ...style }}
            src={src}
            loop
            autoplay
            speed={1}
        />
    );
}
